import { forwardRef } from "react";
import {
  AppBar,
  Box,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog({
  title,
  children,
  disablePadding = false,
  ...dialogProps
}) {
  return (
    <Dialog
      fullScreen
      {...dialogProps}
      slots={{
        transition: Transition,
      }}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={dialogProps.onClose}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        p={disablePadding ? undefined : 2}
        sx={(theme) => ({
          overflowY: "auto",
          height: "100%",
          backgroundColor: theme.palette.background.primary,
        })}
      >
        {children}
      </Box>
    </Dialog>
  );
}
